import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { paymentDetailsStrings } from '../../data/static/strings'
import { useWindowDimensions } from '../../util/util'
import { styles } from './styles'

export interface PaymentDetailsObj {
  paymentMode: string
  cardNumber: string
  bankRefNum: string
  paymentType: string
  customerName: string
}

interface PaymentDetailsProps {
  paymentDetails: PaymentDetailsObj
}
const PaymentDetails: FC<PaymentDetailsProps> = ({ paymentDetails }: PaymentDetailsProps) => {
  const viewPortWidth = useWindowDimensions()
  const themes = styles(viewPortWidth)

  return (
    <Box {...themes.detailsContainer}>
      <TextNew type={'titleBold16'}>{paymentDetailsStrings.labelPaymentDetails}</TextNew>
      <Spacer size={16} />
      <Box {...themes.detailsMainContainer}>
        <Box {...themes.detailsContent} flexDirection={'column'}>
          <Box flexDirection={'row'}>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="BOLD">
                {paymentDetailsStrings?.labelPaymentMode ?? ''}
              </TextNew>
            </Box>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="MEDIUM">
                {paymentDetails?.paymentMode}
              </TextNew>
            </Box>
          </Box>
          <Box flexDirection={'row'} mt={8}>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="BOLD">
                {paymentDetailsStrings?.labelCardNumber ?? ''}
              </TextNew>
            </Box>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="MEDIUM">
                {paymentDetails?.cardNumber}
              </TextNew>
            </Box>
          </Box>
          <Box flexDirection={'row'} mt={8}>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="BOLD">
                {paymentDetailsStrings?.labelBankRefNo ?? ''}
              </TextNew>
            </Box>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="MEDIUM">
                {paymentDetails?.bankRefNum}
              </TextNew>
            </Box>
          </Box>
          {['udf1', 'udf3', 'udf5'].map((item) => (
            <Box flexDirection={'row'} mt={8}>
              <Box {...themes.detailsSubContainer}>
                <TextNew type={'body12'} fontWeight="BOLD">
                  {paymentDetailsStrings?.[item] ?? ''}
                </TextNew>
              </Box>
              <Box {...themes.detailsSubContainer}>
                <TextNew type={'body12'} fontWeight="MEDIUM">
                  {paymentDetails?.[item]}
                </TextNew>
              </Box>
            </Box>
          ))}
        </Box>
        <Box {...themes.divider} />

        <Box {...themes.detailsSideContainer} flexDirection={'column'}>
          <Box flexDirection={'row'}>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="BOLD">
                {paymentDetailsStrings?.labelPaymentType ?? ''}
              </TextNew>
            </Box>
            <Box {...themes.detailsSubContainer}>
              <TextNew type={'body12'} fontWeight="MEDIUM">
                {paymentDetails?.paymentType}
              </TextNew>
            </Box>
          </Box>
          {['offerId', 'settlementRefNumber', 'udf2', 'udf4'].map((item) => (
            <Box flexDirection={'row'} mt={8}>
              <Box {...themes.detailsSubContainer}>
                <TextNew type={'body12'} fontWeight="BOLD">
                  {paymentDetailsStrings?.[item] ?? ''}
                </TextNew>
              </Box>
              <Box {...themes.detailsSubContainer}>
                <TextNew type={'body12'} fontWeight="MEDIUM">
                  {paymentDetails?.[item]}
                </TextNew>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentDetails

/**
 *
 *
 * offerId: data?.offerReferenceId?.length > 0 ? data?.offerReferenceId : 'NA',
      udf1: data?.udf1?.length > 0 ? data?.udf1 : 'NA',
      udf2: data?.udf2?.length > 0 ? data?.udf2 : 'NA',
      udf3: data?.udf1?.length > 0 ? data?.udf3 : 'NA',
      udf4: data?.udf1?.length > 0 ? data?.udf4 : 'NA',
      udf5: data?.udf1?.length > 0 ? data?.udf5 : 'NA',
      settlementRefNumber: data?.settlementRefNumber?.length > 0 ? data?.settlementRefNumber : 'NA',
      accountNumber: data?.accountNumber?.length > 0 ? data?.accountNumber : 'NA',
 */
